module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "c-footer"
  }, [_c('div', {
    staticClass: "c-footer__inner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-footer__col"
  }, [_c('h3', [_vm._v("Apps:")]), _vm._v(" "), _c('ul', {
    staticClass: "c-footer__list"
  }, _vm._l((_vm.apps), function(app) {
    return _c('li', [_c('a', {
      attrs: {
        "href": app.path
      }
    }, [_vm._v(_vm._s(app.name))])])
  }))]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-footer__col"
  }, [_c('h3', [_vm._v("About:")]), _vm._v(" "), _c('ul', {
    staticClass: "c-footer__list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("このサイトについて")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/history"
    }
  }, [_vm._v("更新履歴")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/codogue"
    }
  }, [_vm._v("@codogue")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/mach3ss"
    }
  }, [_vm._v("@mach3ss")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-footer__col"
  }, [_c('p', {
    staticClass: "c-footer__copyright"
  }, [_vm._v("© Codogue.com All Rights Reserved.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1860672","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/component/footer.vue
// module id = 67
// module chunks = 0